/* Smooth scrolling for all funnel pages.
   Vertical: Lenis inertial wheel scrolling (native touch, anchors eased, dialogs/[data-lenis-prevent] scroll natively).
   Horizontal rows (any overflow-x:auto|scroll element): smooth programmatic scroll, soft snap, mouse drag with inertia.
   prefers-reduced-motion: no smoothing, rows stay native. */
(function () {
  if (window.__lxSmooth) return; window.__lxSmooth = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var css = document.createElement('style');
  css.textContent = 'html.lenis,html.lenis body{height:auto}.lenis.lenis-smooth{scroll-behavior:auto!important}.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}.lenis.lenis-stopped{overflow:hidden}[data-smooth-row]{-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain}[data-smooth-row].is-dragging{cursor:grabbing;user-select:none}[data-smooth-row].is-dragging *{pointer-events:none}';
  document.head.appendChild(css);

  function startLenis() {
    if (RM || window.__lenis || !window.Lenis) return;
    var l = new window.Lenis({
      lerp: 0.09, wheelMultiplier: 0.95, smoothWheel: true, anchors: { offset: -12 },
      prevent: function (n) { return !!(n && n.closest && n.closest('[data-lenis-prevent],[role="dialog"],[aria-modal="true"]')); }
    });
    window.__lenis = l;
    l.on('scroll', function () { if (window.ScrollTrigger) window.ScrollTrigger.update(); });
    (function raf(t) { l.raf(t); requestAnimationFrame(raf); })(performance.now());
  }
  if (!RM) {
    if (window.Lenis) startLenis();
    else { var s = document.createElement('script'); s.src = 'https://unpkg.com/lenis@1/dist/lenis.min.js'; s.onload = startLenis; document.head.appendChild(s); }
  }

  function enhance(row) {
    if (row.__smooth) return; row.__smooth = true; row.setAttribute('data-smooth-row', '');
    var snap = getComputedStyle(row).scrollSnapType;
    if (snap && snap !== 'none') { snap = snap.replace('mandatory', 'proximity'); row.style.scrollSnapType = snap; }
    if (!RM) row.style.scrollBehavior = 'smooth';
    if (RM) return;
    var d = null, v = 0, raf = 0, moved = 0;
    function settle() { row.classList.remove('is-dragging'); row.style.scrollSnapType = snap || ''; row.style.scrollBehavior = 'smooth'; }
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || row.scrollWidth <= row.clientWidth + 2) return;
      if (e.target.closest && e.target.closest('button,a,input,select,textarea,[role="radio"]')) return;
      cancelAnimationFrame(raf); d = { x: e.clientX, s: row.scrollLeft, lx: e.clientX, lt: performance.now() }; v = 0; moved = 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (!d) return; var dx = e.clientX - d.x;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) { moved = 1; row.classList.add('is-dragging'); row.style.scrollSnapType = 'none'; row.style.scrollBehavior = 'auto'; }
      var now = performance.now(), dt = Math.max(1, now - d.lt); v = 0.8 * ((e.clientX - d.lx) / dt * 16) + 0.2 * v; d.lx = e.clientX; d.lt = now;
      row.scrollLeft = d.s - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!d) return; d = null; if (!moved) return;
      var tick = function () { v *= 0.93; row.scrollLeft -= v; if (Math.abs(v) > 0.4) raf = requestAnimationFrame(tick); else settle(); };
      raf = requestAnimationFrame(tick);
    });
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  }
  function scan() {
    var all = document.querySelectorAll('[data-row],div[style*="overflow-x"]');
    for (var i = 0; i < all.length; i++) { var o = getComputedStyle(all[i]).overflowX; if (o === 'auto' || o === 'scroll') enhance(all[i]); }
  }
  var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 250); });
  function boot() { scan(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
